import {DataSourceId} from '../../interfaces/DataSource';
import {loadMetadata, loadPrefixesV2} from '../ViewerApiService';
import {EMPTY, merge, Observable, of} from 'rxjs';
import {Metadata, isVersionMetadata} from '../../interfaces/Metadata';
import {RootState} from '../../reducer';
import {VectorSourceSpecification} from 'maplibre-gl';
import {updateSourceConfiguration, updateVersionMetadata} from '../../scenes/MapScene/actions/reducers/data';
import {SourceSpecification} from '@maplibre/maplibre-gl-style-spec';

export interface DataSourceConfig {
    onActivate: () => Observable<unknown>;
    loadMetadata?: () => Observable<unknown>;
    onMetadataReceived?: (metadata: Metadata, state: RootState) => Observable<unknown>;
}

export function dataSourceFactory(dataSource: DataSourceId): DataSourceConfig | null {
    switch (dataSource) {
        case 'avg':
            return {
                onActivate: () => {
                    return merge(
                        loadMetadata(dataSource),
                        loadPrefixesV2(dataSource)
                    );
                },
                loadMetadata: () => loadMetadata(dataSource),
                onMetadataReceived: (metadata, state) => merge(updateTileUrlInSourceConfiguration(dataSource, metadata, state), updateMetadata(dataSource, metadata)),
            } as DataSourceConfig;
        case 'traveltime-drips':
        case 'traveltime-fcd':
        case 'traveltime-other':
            return {
                onActivate: () => {
                    return merge(
                        loadMetadata(dataSource),
                        loadPrefixesV2('travelTimeV2')
                    );
                },
                loadMetadata: () => loadMetadata(dataSource),
                onMetadataReceived: (metadata, state) => merge(updateTileUrlInSourceConfiguration(dataSource, metadata, state), updateMetadata(dataSource, metadata)),

            } as DataSourceConfig;
        case 'fcd':
            return {
                onActivate: () => loadMetadata(dataSource),
                loadMetadata: () => loadMetadata(dataSource),
                onMetadataReceived: (metadata, state) => merge(updateTileUrlInSourceConfiguration(dataSource, metadata, state), updateMetadata(dataSource, metadata)),
            } as DataSourceConfig;
        default:
            return null;
    }
}

function updateTileUrlInSourceConfiguration(dataSourceId: DataSourceId, metadata: Metadata, state: RootState) {
    const sourceConfiguration = state.mapScene.data.sources[dataSourceId].sourceConfiguration;
    if (isVersionMetadata(metadata) && isVectorSourceSpecification(sourceConfiguration)) {
        const newConfig: VectorSourceSpecification = {
            ...sourceConfiguration,
            tiles: sourceConfiguration.tiles?.map(tile => tile.replace('{version}', metadata.version)),
        };

        return of(updateSourceConfiguration(dataSourceId, newConfig));
    }
    return EMPTY;
}

function updateMetadata(dataSourceId: DataSourceId, metadata: Metadata) {
    if (isVersionMetadata(metadata)) {
        return of(updateVersionMetadata(dataSourceId, metadata));
    }
    return EMPTY;
}

function isVectorSourceSpecification(sourceConfiguration: SourceSpecification): sourceConfiguration is VectorSourceSpecification {
    return (
        typeof sourceConfiguration === 'object' &&
        sourceConfiguration !== null &&
        'type' in sourceConfiguration &&
        sourceConfiguration.type === 'vector'
    );
}
